import styles from './MovieList.module.css';
import { toggleMovieStruck } from '../../firebase.js';

// Components
import Movies from './Movies'

export default function MovieList({ listId, moviesList }) {
  const movieInfo = Object.values(moviesList);

  return (
    <>
      <div className={styles.MovieList}>
        <ul>
          {movieInfo && Object.keys(moviesList).length > 0 ? (
            Object.entries(moviesList).map(([movieId, movie]) => (
              <li key={movieId}>
              <Movies
                  listId={listId}
                  movieId={movieId}
                  struck={Boolean(movie.struck)}
                  onToggleStruck={ async () => {
                    const next = !Boolean(movie.struck);
                    await toggleMovieStruck(listId, movieId, next);
                  }}
                  {...movie}
              /> 
              </li>
            )))
            :
            <p>You got no movies!</p>
            }
        </ul>
      </div>
    </>
  )
}
